import { render, staticRenderFns } from "./OrthoShoulderCortisone.vue?vue&type=template&id=1afaf78b&scoped=true"
import script from "./OrthoShoulderCortisone.vue?vue&type=script&lang=js"
export * from "./OrthoShoulderCortisone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afaf78b",
  null
  
)

export default component.exports